import instagram from '../../../../assets/socialIcons/instagram.png';
import facebook from '../../../../assets/socialIcons/facebook.png';
import pintrest from '../../../../assets/socialIcons/pintrest.png';
import linkedin from '../../../../assets/socialIcons/linkedin.png';

const Plan = () => {
  return (
    <div className="border bg-white flex flex-col items-center p-5 text-center space-y-5 relative rounded-lg">
      <p className="text-2xl font-bold">Free Plan</p>
      <div className="flex space-x-3">
        <img className="w-5 h-5" src={instagram} alt="instagram icon" />
        <img className="w-5 h-5" src={facebook} alt="facebook icon" />
        <img className="w-5 h-5" src={pintrest} alt="pintrest icon" />
        <img className="w-5 h-5" src={linkedin} alt="linkedin icon" />
      </div>
      <div className="space-y-2">
        <p>30 post per social account</p>
        <p>Schedule post up to 30 days</p>
        <p>5 Video post per social account</p> <p>5 Instagram story</p>
        <p>Multi account not supported</p> <p>No Analytics</p>
        <p>No comments reply</p>
        <p>Add and manage 1 team member</p>
      </div>
      <button class="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-1 text-center absolute -bottom-10">
        $0/month
      </button>
    </div>
  );
};

export default Plan;
